import { render, staticRenderFns } from "./IncidentDeposits.vue?vue&type=template&id=5bf09f18&"
import script from "./IncidentDeposits.vue?vue&type=script&lang=js&"
export * from "./IncidentDeposits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports